import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionTwoImagesFiveTextsBody,
    SectionTwoImagesFiveTextsDetails,
} from "types/api/blocks/sectionTwoImagesFiveTexts";

function useSectionTwoImagesFiveTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionTwoImagesFiveTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionTwoImagesFiveTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionTwoImagesFiveTextsDetails>({
            url: "/blocks/section-two-images-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionTwoImagesFiveTexts = React.useCallback((body: SectionTwoImagesFiveTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionTwoImagesFiveTextsBody, null>({
            url: "/blocks/section-two-images-five-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionTwoImagesFiveTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-two-images-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionTwoImagesFiveTexts,
        saveSectionTwoImagesFiveTexts,
        deleteSectionTwoImagesFiveTexts
    };
}

export default useSectionTwoImagesFiveTextsApi;